// ** React Imports
// ** Reactstrap Imports

// ** Third Party Components
// ** Custom Components
// ** Default Avatar Image

export function AlertsDropdown() {
  return (
    <></>
  );
}

export default AlertsDropdown;
